// src/components/ui/GlassButton.tsx
import React from 'react';
import './GlassButton.css';

export interface GlassButtonProps {
    children: React.ReactNode;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    variant?: 'primary' | 'ghost' | 'danger' | 'success';
    size?: 'sm' | 'md' | 'lg';
    disabled?: boolean;
    className?: string;
    type?: 'button' | 'submit' | 'reset';
    fullWidth?: boolean;
}

/**
 * Premium glassmorphism button component
 * Features smooth transitions, micro-animations, and distinct visual states
 */
export function GlassButton({
    children,
    onClick,
    variant = 'ghost',
    size = 'md',
    disabled = false,
    className = '',
    type = 'button',
    fullWidth = false,
}: GlassButtonProps) {
    const classes = [
        'glass-button',
        `glass-button--${variant}`,
        `glass-button--${size}`,
        fullWidth ? 'glass-button--full-width' : '',
        disabled ? 'glass-button--disabled' : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <button
            type={type}
            className={classes}
            onClick={onClick}
            disabled={disabled}
        >
            <span className="glass-button__content">{children}</span>
        </button>
    );
}
